import { render, staticRenderFns } from "./B2BReport.vue?vue&type=template&id=d7c4a38a"
import script from "./B2BReport.vue?vue&type=script&lang=js"
export * from "./B2BReport.vue?vue&type=script&lang=js"
import style0 from "./B2BReport.vue?vue&type=style&index=0&id=d7c4a38a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports